<template>
  <DialogWrapper
    close-on-cancel
    destroyOnClose
    append-to-body
    class="reactive-job-application-dialog"
    :loading="loading"
    :title="$t(`${i18nPrefix}.message.reactivateTitle`)"
    saveBtnLabelI18nKey="common.btn.submit"
    :show.sync="isShow"
    @cancel="handleCancel"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      :model="reactivateForm"
      :formLines="formLines"
    ></WrappedForm>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    questionnaire: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      invitationI18nPrefix: 'admin.application.invitation.jobApplicationQuestionnaire',
      loading: false,
      emailTemplateList: [],
      loader: null,
      reactivateForm: {
        questionnaireName: '',
        emailTemplateId: null,
        reason: null
      }
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    formLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      return {
        questionnaireName: {
          label: this.$t(`${this.invitationI18nPrefix}.label.questionnaire`),
          disabled: true
        },
        emailTemplateId: {
          elType: 'el-select',
          label: this.$t(`${this.invitationI18nPrefix}.label.emailTemplate`),
          required: true,
          option: {
            data: this.emailTemplateList,
            labelKey: 'name',
            valueKey: 'id'
          },
          props: { filterable: true },
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }]
        },
        reason: {
          label: this.$t(`${this.i18nPrefix}.message.reactivateReasonLabel`),
          props: {
            type: 'textarea',
            rows: 4,
            placeholder: this.$t(`${this.i18nPrefix}.message.reactivateReason`)
          }
        }
      }
    },
    form () {
      return this.$refs.form
    }
  },
  methods: {
    ...mapActions('notificationTemplate', ['getCompanyEmailTemplateByType']),
    clearForm () {
      this.reactivateForm = {
        questionnaireName: this.questionnaire && this.questionnaire.name,
        emailTemplateId: null,
        reason: null
      }
      this.$nextTick(() => {
        this.form && this.form.clearValidate()
      })
    },
    async loadEmailTemplates () {
      this.loading = true
      try {
        if (!this.loader) {
          this.loader = this.getCompanyEmailTemplateByType({
            email_template_type: 'Job Application Form Invitation'
          }).then(resp => {
            const companyEmailTemplateList = _.filter(resp || [], item => item.company_id !== null)
            this.emailTemplateList = _.map(companyEmailTemplateList, item => ({ ...item, disabled: false }))
          })
        }
        await this.loader
      } finally {
        this.loading = false
      }
    },
    handleCancel () {
      this.isShow = false
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      this.$emit('save', {
        reason: this.reactivateForm.reason,
        emailTemplateId: this.reactivateForm.emailTemplateId
      }, () => {
        this.loading = false
        this.isShow = false
      })
    }
  },
  watch: {
    isShow () {
      if (this.isShow) {
        this.clearForm()
        this.loadEmailTemplates()
      } else {
        this.clearForm()
      }
    },
    questionnaire () {
      if (this.isShow) {
        this.reactivateForm.questionnaireName = this.questionnaire && this.questionnaire.name
      }
    }
  }
}
</script>
